import { render, staticRenderFns } from "./sigin.vue?vue&type=template&id=6664ce3a&scoped=true&"
import script from "./sigin.vue?vue&type=script&lang=js&"
export * from "./sigin.vue?vue&type=script&lang=js&"
import style0 from "./sigin.vue?vue&type=style&index=0&id=6664ce3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664ce3a",
  null
  
)

export default component.exports